import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { globalDk } from './presets/global-dk.config';
import { insuranceMypageDk } from './presets/insurance-mypage.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationContactLendmeDkConfig } from './presets/organisation-contact-lendme-dk.config';
import { productConfigLimited } from './presets/product-config.preset';
import { serviceTrustpilotLendmeDkConfig } from './presets/service-trustpilot-lendme-dk.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansDkConfig } from './presets/unsecured-loans-dk.config';

export const global: GlobalConfig = {
  brand: 'lendme.dk',
  ...globalDk,
};

export const site: SiteConfig = {
  domain: 'lendme.dk',
  name: 'LendMe',
  theme: {
    name: 'lendme',
    brand: 'lendme',
  },
  path: {
    loansApply: '/anvend/laan', // MV-178: site-one form
    mypage: '/min-side', // MV-178: legacy mypage
    mypageOverview: '/min-side', // MV-1319: site-one mypage overview
    mypageLoans: '/min-side/laan', // MV-178: site-one mypage
    insurance: '/forsikring/ansoeg', // MVF-456: site-one /insurance/apply
    insuranceLegacy: 'https://forsikring.lendme.dk', // MV-178: the legacy insurance app
    ...insuranceMypageDk,
  },
  ...organisationContactLendmeDkConfig,
  services: {
    cms: {
      provider: 'sanity',
      projectId: 's5ef53qn',
      dataset: 'production',
    },
    trustpilot: {
      ...serviceTrustpilotLendmeDkConfig,
      reviewSnippet: true,
      showInForms: true,
    },
    gtm: 'GTM-K43BCC',
    ga: 'G-LJR284BLVE',
    vwo: { id: '1091428' },
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
    // Explicit entry (mirrors axofinans.no.ts) for deliberate autoCapture/
    // sessionReplay control — an absent entry already defaults to enabled
    // (see StatsigProvider's `enabled = Boolean((statsig?.enabled ?? true)
    // && sdkKey)`), so this does not switch Statsig on by itself.
    statsig: {
      enabled: true,
      autoCapture: false,
      sessionReplay: false,
      proxyEnabled: true,
    },
  },
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    // MVX-679 (CCD2 R04): the notice only. The SE credit-intermediary footer
    // stays off in Denmark.
    hasAutomatedDecisionNotice: true,
    hasCriterionLabel: true,
    offers: {
      ...myPageOffersConfig.offers,
      isAnnualRateEnabled: true,
      hasCostSummary: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansDkConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const product: ProductConfig = productConfigLimited;
